import { useTranslation } from 'react-i18next';

import ccCoin from '../../../../../assets/social_coin_2x.webp';
import sweepCoin from '../../../../../assets/sweep_coin_2x.webp';
import type { CoinType } from '../../../../../stores/cointype/CoinTypeStore';
import { useStores } from '../../../../../stores/useStores';
import { FreeSpinsWidgetTimer } from '../FreeSpinsWidgetTimer/FreeSpinsWidgetTimer';

import styles from './FreeSpinsWideWidget.module.scss';

interface FreeSpinsWideWidgetProps {
  eventId: string;
  widgetImageUrl: string;
  count: number;
  betAmountValue: string;
  coinType: CoinType;
}

export function FreeSpinsWideWidget(props: FreeSpinsWideWidgetProps) {
  const { widgetImageUrl, count, betAmountValue, coinType, eventId } = props;
  const { userFreeSpinsStore } = useStores();
  const { t } = useTranslation();

  const timerValue = userFreeSpinsStore.getFreeSpinTimerFormatted(eventId, t);
  const noTimer = !timerValue;

  return (
    <div className={styles.container}>
      <div className={styles.ellipse}>
        <img alt="" className={styles.img} src={widgetImageUrl} />
      </div>
      <div className={styles.content}>
        <div className={styles.textRow}>
          <span className={styles.countText}>{count}</span>
          <span className={styles.text}>{t('frb.freeSpins')}</span>
        </div>
        <div className={styles.coinsContainer}>
          <img alt="" className={styles.coinImg} src={coinType === 'SC' ? sweepCoin : ccCoin}></img>
          <span className={styles.coinText}>{betAmountValue}</span>
        </div>
        {noTimer ? null : <FreeSpinsWidgetTimer extended className={styles.timer} eventId={eventId} />}
      </div>
    </div>
  );
}
